

export const FREE_INVENTORY_LIMIT = 100;

export const VALID_TIERS = ["free", "pro", "enterprise"];


export const FEATURE_PLANS = {
  // Inventory
  inventory_limit:    ["free","monthly","annual","trial"],  // free has limit of 100
  add_card_api:       ["monthly","annual","trial"],
  // Inventory features
  consignors:         ["monthly","annual","trial"],
  qr_labels:          ["monthly","annual","trial"],
  import_collectr:    ["free","monthly","annual","trial"],
  // Show Mode
  show_sell_buy:      ["free","monthly","annual","trial"],
  show_trade:         ["monthly","annual","trial"],
  show_attach_buyer:  ["monthly","annual","trial"],
  // Kiosk
  kiosk:              ["monthly","annual","trial"],
  // CRM
  buyers_list:        ["monthly","annual","trial"],
  // Pricing
  market_pricing:     ["monthly","annual","trial"],
  batch_refresh:      ["monthly","annual","trial"],
  card_scanning:      ["monthly","annual","trial"],
  quick_scan:         ["monthly","annual","trial"],
  // Reports
  reports_sales:      ["free","monthly","annual","trial"],
  reports_advanced:   ["monthly","annual","trial"],
  // Settings
  settings_edit:      ["monthly","annual","trial"],
  // Aliases
  aliases:            ["monthly","annual","trial"],
};


export const FEATURE_TIERS = {
  multi_location:     ["enterprise"],
  category_pricing:   ["enterprise"],
};


export function resolveTier(vendor) {
  if (vendor?.tier && VALID_TIERS.includes(vendor.tier)) return vendor.tier;
  const plan = vendor?.plan || "free";
  return plan === "free" ? "free" : "pro";
}


export function canUseFeature(feature, { plan, tier, isAdmin }) {
  if (isAdmin) return true;
  const allowedPlans = FEATURE_PLANS[feature];
  if (allowedPlans && !allowedPlans.includes(plan)) return false;
  const allowedTiers = FEATURE_TIERS[feature];
  if (allowedTiers && !allowedTiers.includes(tier)) return false;
  return true;
}
